export const routerFutureConfig = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};
